import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA5aLUl0W9td8Bspm0aZq4YGn6mdeCuLhE",
  authDomain: "whub-server.firebaseapp.com",
  projectId: "whub-server",
  storageBucket: "whub-server.firebasestorage.app",
  messagingSenderId: "233120630355",
  appId: "1:233120630355:web:95877e3ae358d5a80ba8a6",
};
// const firebaseConfig = {
//   apiKey: 'AIzaSyBH-K5eW6k3472QCnSAeEvxPuw9J2nxwB0',
//   authDomain: 'orunaal-ecommerce-c9272.firebaseapp.com',
//   projectId: 'orunaal-ecommerce-c9272',
//   storageBucket: 'orunaal-ecommerce-c9272.firebasestorage.app',
//   messagingSenderId: '683464489009',
//   appId: '1:683464489009:web:bb3de2b5758a081bebfd10',
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Primary auth instance (for current user session)
export const auth = getAuth(app);

// Secondary auth instance (for creating users without affecting current session)
// This prevents auto-login when admin creates a new user
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);

export const db = getFirestore(app);
export default app;
